import React, { useState, useRef } from 'react';

const TailoredSolutionsSection = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const videoRef = useRef(null);

  const handleWatchDemo = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handleFullscreen = async () => {
    if (videoRef.current) {
      try {
        await videoRef.current.requestFullscreen();
        videoRef.current.play();
      } catch (error) {
        console.log('Fullscreen not available', error);
      }
    }
  };

  const handleEscapeKey = (e) => {
    if (e.key === 'Escape') {
      handleCloseModal();
    }
  };

  const solutions = [
    {
      id: 0,
      title: 'Custom Web Platforms',
      subtitle: 'Scalable & responsive design',
      description: 'Designed exactly to your business needs, focusing on high-speed performance, engaging user experience, and scalable architecture.',
      features: ['Custom Built', 'SEO Ready', 'Responsive'],
      video: '/img/car.mp4',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      )
    },
    {
      id: 1,
      title: 'Educational Platform',
      subtitle: 'Online learning & live classes',
      description: 'Comprehensive e-learning platform with live classes, interactive study materials, progress tracking, and personalized learning paths for professional and academic education.',
      features: ['Live Classes', 'Study Materials', 'Progress Tracking'],
      video: '/img/ca.mp4',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      id: 2,
      title: 'School Management ERP',
      subtitle: 'Complete academic administration',
      description: 'Comprehensive education platforms tailored to your institutional rules. Streamline admissions, fees, and daily administration effortlessly.',
      features: ['Academics', 'Fee Management', 'Portals'],
      video: '/img/school.mp4',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      id: 3,
      title: 'Hospital Management ERP',
      subtitle: 'Patient & operational care',
      description: 'Secure, high-availability healthcare systems customized for your clinical workflows. Simplify patient records, scheduling, and billing.',
      features: ['Patient Care', 'Security', 'Billing'],
      video: '/img/hospital.mp4',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      )
    }
    // {
    //   id: 4,
    //   title: 'Digital Marketing Strategy',
    //   subtitle: 'SEO, SMM & targeted growth',
    //   description: 'Data-driven marketing designed to elevate your brand presence, attract the right audience, and maximize return on investment.',
    //   features: ['SEO', 'SMM', 'PPC Campaigns'],
    //   video: '/img/car.mp4',
    //   icon: (
    //     <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    //     </svg>
    //   )
    // }
  ];

  const current = solutions[activeTab];

  return (
    <section className="relative bg-gray-900 py-20 lg:py-32 overflow-hidden border-b border-gray-800">
      {/* Abstract Glows */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-[150px] pointer-events-none z-0"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none z-0"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        
        {/* LEFT: TAB BUTTONS */}
        <div className="lg:col-span-5">
          {/* Badge */}
          <div className="inline-flex items-center border border-gray-700 px-4 py-2 bg-gray-800/50 backdrop-blur-sm text-xs font-bold uppercase tracking-widest text-amber-400 mb-6 rounded-md shadow-lg">
            <span className="w-2 h-2 bg-amber-400 rounded-full mr-3 shadow-[0_0_8px_rgba(251,191,36,0.8)]"></span>
            Tailored Solutions
          </div>
          
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight uppercase mb-8 text-white">
            Architecting Your <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">Digital Success</span>
          </h2>

          {/* Tab Buttons */}
          <div className="flex flex-col gap-2">
            {solutions.map((solution) => (
              <button
                key={solution.id}
                onClick={() => setActiveTab(solution.id)}
                className={`group flex items-center justify-between p-4 lg:px-6 w-full text-left rounded-2xl transition-all duration-300 relative overflow-hidden ${
                  activeTab === solution.id
                    ? 'bg-gray-800/60 border-gray-700 text-white'
                    : 'hover:bg-gray-800/60 text-gray-400 border-transparent hover:border-gray-700'
                } border hover:shadow-lg`}
              >
                {/* Left Border Line */}
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-transparent group-hover:bg-amber-500/50 transition-colors" 
                  style={{background: activeTab === solution.id ? 'rgba(245, 158, 11, 0.5)' : 'transparent'}}
                ></div>

                {/* Content */}
                <div className="flex items-center gap-5 relative z-10 w-full">
                  {/* Icon Box */}
                  <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-gray-800/80 text-gray-400 flex items-center justify-center border border-gray-700/50 shadow-inner group-hover:text-amber-400 transition-all duration-300 group-hover:scale-110 group-hover:-rotate-3"
                    style={{
                      backgroundColor: activeTab === solution.id ? 'rgba(217, 119, 6, 0.2)' : 'rgba(55, 65, 81, 0.8)',
                      color: activeTab === solution.id ? '#fbbf24' : undefined
                    }}
                  >
                    {solution.icon}
                  </div>
                  
                  {/* Text */}
                  <div className="flex flex-col items-start text-left">
                    <span className={`text-lg font-bold tracking-wide transition-colors ${
                      activeTab === solution.id ? 'text-white' : 'text-gray-300 group-hover:text-white'
                    }`}>
                      {solution.title}
                    </span>
                    <span className={`text-xs font-medium mt-1 transition-colors ${
                      activeTab === solution.id ? 'text-amber-500/80' : 'text-gray-500 group-hover:text-amber-500/80'
                    }`}>
                      {solution.subtitle}
                    </span>
                  </div>
                </div>

                {/* Indicator Dot */}
                <span 
                  className="w-2 h-2 bg-amber-500 rounded-full absolute right-6 transition-all duration-300 shadow-[0_0_12px_rgba(245,158,11,1)]"
                  style={{
                    opacity: activeTab === solution.id ? 1 : 0,
                    transform: activeTab === solution.id ? 'scale(1)' : 'scale(0)'
                  }}
                ></span>
              </button>
            ))}
          </div>
        </div>

        {/* RIGHT: DYNAMIC CONTENT CARD */}
        <div className="lg:col-span-7 relative h-[520px] sm:h-[480px] lg:h-[580px] mt-8 lg:mt-0">
          {/* Video Card */}
          <div className="absolute inset-0 bg-gray-950 border border-gray-800 rounded-[2rem] overflow-hidden shadow-2xl transition-all duration-700 group flex flex-col justify-end">
            {/* Video Background */}
            <div className="absolute inset-0 w-full h-full opacity-60 z-0 bg-black">
              <video 
                ref={videoRef}
                autoPlay 
                loop 
                muted 
                playsInline 
                src={current.video}
                className="w-full h-full object-contain"
              ></video>
            </div>

            {/* Border */}
            <div className="absolute inset-0 border-[6px] border-white/5 rounded-[2rem] pointer-events-none z-20 transition-colors duration-500 group-hover:border-amber-500/20"></div>

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-900/60 to-transparent z-10 transition-opacity duration-500"></div>

            {/* Content Section */}
            <div className="relative z-20 p-4 sm:p-6 lg:p-8 w-full transition-all duration-500">
              <div className="backdrop-blur-xl bg-black/40 border border-white/10 rounded-2xl sm:rounded-3xl p-5 sm:p-8 transform transition-all duration-700 hover:bg-black/50 hover:border-amber-500/30">
                {/* Badge */}
                <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-500/10 border border-amber-500/20 rounded-full mb-4 sm:mb-6">
                  <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(245,158,11,0.8)]"></span>
                  <span className="text-[10px] font-bold text-amber-400 uppercase tracking-widest">Bespoke Solution</span>
                </div>

                {/* Title */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-2 sm:mb-4 tracking-tight">
                  {current.title}
                </h3>

                {/* Description */}
                <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-4 sm:mb-8 max-w-lg">
                  {current.description}
                </p>

                {/* Features Tags */}
                <div className="flex flex-wrap gap-2 sm:gap-3 mb-4 sm:mb-6">
                  {current.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="flex items-center gap-1.5 px-3 py-1.5 sm:px-4 sm:py-2 bg-white/5 hover:bg-white/10 transition-colors border border-white/10 rounded-lg sm:rounded-xl text-[10px] sm:text-xs font-bold text-gray-200 tracking-wide"
                    >
                      <svg className="w-3.5 h-3.5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      {feature}
                    </span>
                  ))}
                </div>

                {/* CTA Section */}
                <div className="flex items-center gap-3 sm:gap-4 pt-4 border-t border-white/10">
                  <button 
                    onClick={handleWatchDemo}
                    className="flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 bg-amber-500 hover:bg-amber-600 text-black text-[10px] sm:text-xs font-bold uppercase tracking-wider rounded-lg sm:rounded-xl transition-all duration-300 hover:shadow-[0_0_15px_rgba(245,158,11,0.4)] hover:-translate-y-0.5">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M4 4l12 6-12 6z" />
                    </svg>
                    Watch Live Demo
                  </button>
                  <span className="text-[10px] sm:text-xs text-gray-400 font-medium tracking-wide flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></span>
                    Video Preview
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* VIDEO MODAL */}
      {showModal && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={handleCloseModal}
          onKeyDown={handleEscapeKey}
          tabIndex={0}
        >
          <div 
            className="relative w-full max-w-4xl bg-gray-950 border border-amber-500/30 rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={handleCloseModal}
              className="absolute top-4 right-4 z-10 p-2 bg-black/60 hover:bg-amber-500 rounded-full transition-all duration-300 group"
              title="Close (ESC)"
            >
              <svg className="w-6 h-6 text-white group-hover:text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Fullscreen Button */}
            <button
              onClick={handleFullscreen}
              className="absolute bottom-4 right-4 z-10 p-3 bg-gradient-to-br from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black rounded-full transition-all duration-300 group shadow-lg hover:shadow-amber-500/40 hover:scale-110"
              title="Fullscreen (Click to expand)"
            >
              <svg className="w-5 h-5 animate-expand-corners" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <g strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
                  {/* Top Left Corner */}
                  <path d="M3 3v6h6" />
                  {/* Top Right Corner */}
                  <path d="M21 3v6h-6" />
                  {/* Bottom Left Corner */}
                  <path d="M3 21v-6h6" />
                  {/* Bottom Right Corner */}
                  <path d="M21 21v-6h-6" />
                </g>
              </svg>
            </button>

            {/* Video Container */}
            <div className="w-full bg-black aspect-video">
              <video 
                ref={videoRef}
                autoPlay 
                controls
                playsInline 
                src={current.video}
                className="w-full h-full object-contain"
              ></video>
            </div>

            {/* Info Section */}
            <div className="p-6 border-t border-white/10 bg-gradient-to-r from-gray-950 to-gray-900">
              <h3 className="text-xl font-bold text-white mb-2">{current.title}</h3>
              <p className="text-gray-300 text-sm">{current.description}</p>
              <div className="flex flex-wrap gap-2 mt-4">
                {current.features.map((feature, idx) => (
                  <span 
                    key={idx}
                    className="px-3 py-1 text-xs font-semibold text-amber-400 bg-amber-500/10 border border-amber-500/30 rounded-full"
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TailoredSolutionsSection;
